import React, { useState, useEffect } from 'react';
import { MenuOutlined, UserOutlined, EditOutlined, LogoutOutlined } from '@ant-design/icons';
import { Drawer, Button, Space } from 'antd';
import '../../composant/ComposantAPP/Styles/Header.css';
import logo from '../../assets/ispatec_logo.png';

const Header = ({ onMenuClick }) => {
  const [menuDrawerVisible, setMenuDrawerVisible] = useState(false);
  const [profileDrawerVisible, setProfileDrawerVisible] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);


  const [role, setRole] = useState(null);

useEffect(() => {
  const userStr = localStorage.getItem('employer');
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      setCurrentUser(user); 
      const hasAdminRole = user.roles?.some(role => role.nomrole === 'ROLE_ADMIN');
      const hasInfluenceurRole = user.roles?.some(role => role.nomrole === 'ROLE_INFLUENCEUR');

      if (hasAdminRole) setRole('ROLE_ADMIN');
      else if (hasInfluenceurRole) setRole('ROLE_INFLUENCEUR');
      else setRole('ROLE_USERS');
    } catch (e) {
      console.error('Erreur parse employer localStorage', e);
    }
  }
}, []);

  const showMenuDrawer = () => setMenuDrawerVisible(true);
  const closeMenuDrawer = () => setMenuDrawerVisible(false);

  const showProfileDrawer = () => setProfileDrawerVisible(true);
  const closeProfileDrawer = () => setProfileDrawerVisible(false);

  const handleClick = (key) => {
    if (onMenuClick) onMenuClick(key);
    setMenuDrawerVisible(false);
  };

  const handleModifyProfile = () => {
    alert("Modifier profil cliqué");
    closeProfileDrawer();
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('employer');
    localStorage.removeItem('telephone');
    window.location.href = '/login';
  };

  const getMenuItems = () => {
    if (role === 'ROLE_ADMIN') {
      return (
        <ul className="nav-menu">
          <li onClick={() => handleClick('admin')}>Admin</li>
          <li onClick={() => handleClick('attenteValidation')}>Attente Validation</li>
          <li onClick={() => handleClick('preinscriptions')}>Pré-inscriptions</li>
          <li onClick={() => handleClick('InscriptionValide')}>Inscription Validé</li>
          <li onClick={() => handleClick('influenceurs')}>Influenceurs inscrits</li>
          <li
            className="nav-user"
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
            onClick={showProfileDrawer}
          >
            Profil <UserOutlined style={{ fontSize: 18 }} />
          </li>
        </ul>
      );
    } else if (role === 'ROLE_INFLUENCEUR') {
      return (
        <ul className="nav-menu">
          <li onClick={() => handleClick('Promouvoir')}>Promouvoir</li>
          <li onClick={() => handleClick('preinscriptions')}>Pré-inscriptions</li>
          <li onClick={() => handleClick('InscriptionValide')}>Inscription Validé</li>
          <li
            className="nav-user"
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
            onClick={showProfileDrawer}
          >
            Profil <UserOutlined style={{ fontSize: 18 }} />
          </li>
        </ul>
      );
    } else {
      // Menu simplifié par défaut
      return (
        <ul className="nav-menu">
          <li onClick={() => handleClick('preinscriptions')}>Pré-inscriptions</li>
          <li
            className="nav-user"
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8 }}
            onClick={showProfileDrawer}
          >
            Profil <UserOutlined style={{ fontSize: 18 }} />
          </li>
        </ul>
      );
    }
  };

  const menuItems = getMenuItems();

  return (
    <header className="main-header">
      <div className="logo-section">
        <img src={logo} alt="Logo" className="header-logo" />
      </div>

      <nav className="desktop-menu">
        {menuItems}
      </nav>

      <Button
        className="mobile-menu-button"
        type="text"
        icon={<MenuOutlined />}
        onClick={showMenuDrawer}
      />

      <Drawer
        title="Menu"
        placement="right"
        onClose={closeMenuDrawer}
        open={menuDrawerVisible}
        className="mobile-drawer"
      >
        {menuItems}
      </Drawer>

      <Drawer
        title={`Profil: ${currentUser?.nom || currentUser?.userSystem?.nom || 'Utilisateur'}`}
        placement="right"
        onClose={closeProfileDrawer}
        open={profileDrawerVisible}
        className="profile-drawer"
      >
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <Button icon={<EditOutlined />} type="primary" block onClick={handleModifyProfile}>
            Modifier Profil
          </Button>
          <Button icon={<LogoutOutlined />} danger block onClick={handleLogout}>
            Se Déconnecter
          </Button>
        </Space>
      </Drawer>
    </header>
  );
};

export default Header;
